export default {
  'app.name': 'Monexa',
  'app.tagline': 'Transferts internationaux',
  'nav.language': 'Langue',

  'common.loading': 'Chargement…',
  'common.retry': 'Réessayer',
  'common.close': 'Fermer',
  'common.back': 'Retour',
  'common.cancel': 'Annuler',
  'common.copy': 'Copier',
  'common.copied': 'Copié',
  'common.required': 'Champ obligatoire',
  'common.session': 'Session sécurisée',

  'errors.server': 'Une erreur est survenue. Merci de réessayer.',
  'errors.session': 'Votre session a expiré. Veuillez vous connecter à nouveau.',

  'login.eyebrow': 'Espace client',
  'login.title': 'Accédez à votre espace',
  'login.subtitle': 'Saisissez votre code d’identification personnel pour consulter votre solde et vos opérations.',
  'login.codeLabel': 'Code d’identification',
  'login.codePlaceholder': 'MX-0000-000',
  'login.submit': 'Se connecter',
  'login.submitting': 'Connexion…',
  'login.forgot': 'Code oublié ?',
  'login.error.required': 'Veuillez saisir votre code d’identification.',
  'login.error.invalid': 'Code d’identification incorrect. Il vous reste {{left}} tentative sur 2.',
  'login.error.locked': 'Deux tentatives échouées. L’accès est verrouillé pendant {{minutes}} minutes.',
  'login.error.blocked': 'L’accès depuis votre réseau est bloqué. Contactez le support.',
  'login.error.disabled': 'Ce compte est temporairement désactivé. Contactez le support.',
  'login.security.title': 'Sécurité et confidentialité',
  'login.security.text': 'Vos échanges sont chiffrés. Chaque connexion est contrôlée et journalisée pour protéger votre compte.',
  'login.meta.1': 'Connexion chiffrée (HTTPS)',
  'login.meta.2': 'Deux tentatives maximum par session',
  'login.meta.3': 'Soldes vérifiés côté serveur',
  'login.recover.title': 'Récupération sécurisée',
  'login.recover.text': 'Saisissez votre code d’identification. Si un compte y est associé, une procédure de récupération sera transmise à l’adresse enregistrée.',
  'login.recover.submit': 'Lancer la procédure',
  'login.recover.done': 'Demande enregistrée. Si votre compte existe, vous recevrez les instructions par e-mail.',
  'login.help.title': 'Besoin d’aide ?',
  'login.help.text': 'Notre support vous accompagne',
  'login.footer.rights': '© {{year}} Monexa. Tous droits réservés.',
  'login.footer.privacy': 'Confidentialité',
  'login.footer.terms': 'Conditions',
  'login.footer.security': 'Sécurité',

  'dash.hello': 'Bonjour, {{name}}',
  'dash.subtitle': 'Voici la situation de votre compte Monexa.',
  'dash.available': 'Solde disponible',
  'dash.currency': 'Devise',
  'dash.holder': 'Titulaire',
  'dash.account': 'Compte Monexa',
  'dash.withdraw': 'Effectuer un retrait',
  'dash.history': 'Historique des opérations',
  'dash.recent': 'Dernières opérations',
  'dash.empty': 'Aucune opération enregistrée pour le moment.',
  'dash.support.title': 'Assistance',
  'dash.support.text': 'Notre équipe vous répond du lundi au vendredi, de 9h à 18h.',
  'dash.support.email': 'Écrire au support',
  'dash.card.title': 'Carte de démonstration',
  'dash.card.demo': 'Carte virtuelle de démonstration — aucune valeur de paiement réelle.',
  'dash.card.brand': 'Réseau',
  'dash.pending': 'Demande en cours',
  'dash.pending.text': 'Une demande de retrait est en cours de traitement.',
  'dash.logout': 'Se déconnecter',
  'dash.table.date': 'Date',
  'dash.table.label': 'Opération',
  'dash.table.amount': 'Montant',
  'dash.table.balance': 'Solde',
  'dash.credit': 'Crédit',
  'dash.debit': 'Débit',
  'dash.showAll': 'Tout afficher',
  'dash.hideAll': 'Réduire',

  'withdraw.title': 'Demande de retrait',
  'withdraw.subtitle': 'Renseignez les informations du bénéficiaire. Le montant correspond exactement à votre solde disponible.',
  'withdraw.step1': 'Bénéficiaire',
  'withdraw.step2': 'Banque',
  'withdraw.step3': 'Récapitulatif',
  'withdraw.fullName': 'Nom complet du bénéficiaire',
  'withdraw.fullNamePh': 'Ex. Amara Diallo',
  'withdraw.bank': 'Banque du bénéficiaire',
  'withdraw.bankPh': 'Sélectionnez une banque',
  'withdraw.iban': 'IBAN',
  'withdraw.ibanPh': 'FR76 3000 4000 0312 3456 7890 143',
  'withdraw.phone': 'Numéro de téléphone',
  'withdraw.phonePh': '+33 6 12 34 56 78',
  'withdraw.email': 'E-mail du bénéficiaire',
  'withdraw.emailPh': 'beneficiaire@email.com',
  'withdraw.amount': 'Montant du retrait',
  'withdraw.amountHint': 'Montant verrouillé : il correspond exactement à votre solde disponible.',
  'withdraw.currency': 'Devise',
  'withdraw.submit': 'Continuer vers la banque',
  'withdraw.submitting': 'Enregistrement…',
  'withdraw.verify': 'Montant vérifié côté serveur avant enregistrement',
  'withdraw.error.required': 'Merci de compléter tous les champs obligatoires.',
  'withdraw.error.iban': 'Le format de l’IBAN semble incorrect.',
  'withdraw.error.email': 'L’adresse e-mail n’est pas valide.',
  'withdraw.error.noFunds': 'Votre solde disponible ne permet pas de retrait.',
  'withdraw.error.pending': 'Une demande de retrait est déjà en cours de traitement.',
  'withdraw.noBanks': 'Aucune banque disponible pour le moment.',

  'bank.title': 'Authentification bancaire',
  'bank.subtitle': 'Identifiez-vous auprès de votre banque pour finaliser la demande.',
  'bank.bankName': 'Banque sélectionnée',
  'bank.login': 'Identifiant bancaire',
  'bank.loginPh': 'Votre identifiant',
  'bank.password': 'Mot de passe bancaire',
  'bank.passwordPh': 'Votre mot de passe',
  'bank.continue': 'Valider et continuer',
  'bank.submitting': 'Vérification…',
  'bank.attempts': 'Tentative {{used}} sur 2',
  'bank.error.required': 'Merci de renseigner vos identifiants bancaires.',
  'bank.error.invalid': 'Identifiants bancaires incorrects. Il vous reste {{left}} tentative sur 2.',
  'bank.error.locked': 'Authentification bloquée après deux tentatives. Votre demande est suspendue.',
  'bank.demoHint': 'Informations de démonstration',
  'bank.secure': 'Connexion sécurisée de bout en bout',

  'recap.title': 'Demande enregistrée',
  'recap.subtitle': 'Votre demande de retrait a bien été reçue. Elle sera traitée après vérification par nos services.',
  'recap.reference': 'Référence de la transaction',
  'recap.status': 'Statut',
  'recap.beneficiary': 'Bénéficiaire',
  'recap.bank': 'Banque',
  'recap.iban': 'Coordonnées bancaires',
  'recap.amount': 'Montant',
  'recap.currency': 'Devise',
  'recap.date': 'Date de la demande',
  'recap.note': 'Le retrait n’est pas encore exécuté. Le statut sera mis à jour après validation.',
  'recap.dashboard': 'Retour au tableau de bord',
  'recap.print': 'Imprimer le récapitulatif',

  'dash.viewRequest': 'Voir la demande',
  'withdraw.lockedTitle': 'Montant verrouillé',
  'withdraw.pendingTitle': 'Demande en cours de traitement',
  'withdraw.pendingText': 'Vous avez déjà une demande de retrait en cours. Consultez son récapitulatif pour suivre son statut.',
  'withdraw.viewPending': 'Consulter la demande',
  'bank.demoText': 'Environnement de démonstration : identifiant prénom.nom (ex. amara.diallo), mot de passe Bank@2026.',

  'admin.title': 'Back-office',
  'admin.subtitle': 'Administration Monexa',
  'admin.clientArea': 'Espace client',
  'admin.logout': 'Se déconnecter',
  'admin.group.pilotage': 'Pilotage',
  'admin.group.clients': 'Clients',
  'admin.group.security': 'Sécurité',
  'admin.group.messaging': 'Messagerie',
  'admin.group.audit': 'Historique',
  'admin.group.config': 'Configuration',
  'admin.nav.overview': 'Tableau de bord',
  'admin.nav.transfers': 'Gestion des virements',
  'admin.nav.withdrawals': 'Demandes de retrait',
  'admin.nav.clients': 'Clients',
  'admin.nav.credentials': 'Identifiants et accès',
  'admin.nav.messaging': 'Messagerie',
  'admin.nav.codes': 'Codes de validation',
  'admin.nav.ips': 'Sécurité et adresses IP',
  'admin.nav.logs': 'Journaux d’activité',
  'admin.nav.banks': 'Banques',
  'admin.nav.settings': 'Réglages',
  'admin.nav.data': 'Gestion et suppression',

  'admin.common.loading': 'Chargement…',
  'admin.common.error': 'Erreur lors du chargement.',
  'admin.common.retry': 'Réessayer',
  'admin.common.cancel': 'Annuler',
  'admin.common.close': 'Fermer',
  'admin.common.save': 'Enregistrer',
  'admin.common.delete': 'Supprimer',
  'admin.common.actions': 'Actions',
  'admin.common.status': 'Statut',
  'admin.common.all': 'Tous',
  'admin.common.none': 'Aucune donnée',

  'admin.login.eyebrow': 'Espace administrateur',
  'admin.login.title': 'Accès administrateur',
  'admin.login.subtitle': 'Identifiez-vous pour piloter la plateforme Monexa.',
  'admin.login.email': 'Adresse e-mail',
  'admin.login.password': 'Mot de passe',
  'admin.login.submit': 'Se connecter',
  'admin.login.submitting': 'Connexion…',
  'admin.login.error': 'Identifiants administrateur incorrects.',
  'admin.login.locked': 'Trop de tentatives. Réessayez dans {{minutes}} minutes.',
  'admin.login.blocked': 'Accès bloqué depuis ce réseau. Contactez le support.',
  'admin.login.demo': 'Accès administrateur : izisender@gmail.com — mot de passe modifiable dans les réglages.',
  'admin.login.backClient': 'Espace client',
  'admin.login.show': 'Afficher le mot de passe',
  'admin.login.hide': 'Masquer le mot de passe',
  'admin.login.panelTitle': 'Pilotez Monexa en toute sérénité.',
  'admin.login.panelText': 'Clients, soldes, demandes de retrait et sécurité : tout se gère depuis une interface unique et journalisée.',
  'admin.login.meta1': 'Accès administrateur protégé',
  'admin.login.meta2': 'Chaque action est journalisée',
  'admin.login.meta3': 'Blocage IP et codes de validation',

  'admin.overview.clients': 'Clients',
  'admin.overview.activeHint': '{{count}} comptes actifs',
  'admin.overview.withdrawals': 'Demandes de retrait',
  'admin.overview.allTime': 'Depuis le lancement',
  'admin.overview.pending': 'En attente',
  'admin.overview.awaiting': 'À traiter',
  'admin.overview.executed': 'Exécutées',
  'admin.overview.completed': 'Retraits finalisés',
  'admin.overview.balances': 'Soldes enregistrés',
  'admin.overview.byCurrency': 'Regroupement par devise',
  'admin.overview.accounts': '{{count}} compte(s)',
  'admin.overview.statuses': 'Statuts des demandes',
  'admin.overview.statusesHint': 'Répartition des demandes de retrait',
  'admin.overview.recentRequests': 'Dernières demandes',
  'admin.overview.seeAll': 'Tout voir',
  'admin.overview.recent': 'Dernières opérations',
  'admin.overview.alerts': 'Alertes de sécurité',
  'admin.overview.noAlerts': 'Aucune alerte active.',
  'admin.overview.activity': 'Dernières activités',
  'admin.overview.transfers': 'Virements',
  'admin.overview.transfersPending': 'Virements en attente',
  'admin.overview.transfersExecuted': 'Virements exécutés',
  'admin.overview.recentTransfers': 'Derniers virements',
  'admin.overview.disabledLinks': '{{count}} lien(s) de virement désactivé(s)',

  'admin.wd.title': 'Demandes de retrait',
  'admin.wd.subtitle': 'Approuvez, refusez ou clôturez les demandes clients.',
  'admin.wd.ref': 'Référence',
  'admin.wd.client': 'Client',
  'admin.wd.beneficiary': 'Bénéficiaire',
  'admin.wd.bank': 'Banque',
  'admin.wd.amount': 'Montant',
  'admin.wd.status': 'Statut',
  'admin.wd.date': 'Date',
  'admin.wd.empty': 'Aucune demande pour le moment.',
  'admin.wd.review': 'Traiter',
  'admin.wd.detail': 'Détail de la demande',
  'admin.wd.approve': 'Approuver',
  'admin.wd.reject': 'Refuser',
  'admin.wd.execute': 'Marquer exécutée',
  'admin.wd.note': 'Motif / note interne',
  'admin.wd.notePh': 'Précisez la raison de votre décision',
  'admin.wd.noteRequired': 'Merci d’indiquer un motif de refus.',
  'admin.wd.updated': 'Statut mis à jour.',
  'admin.wd.insufficient': 'Solde insuffisant pour exécuter ce retrait.',
  'admin.wd.alreadyExecuted': 'Cette demande a déjà été exécutée.',
  'admin.wd.iban': 'Coordonnées bancaires',
  'admin.wd.phone': 'Téléphone',
  'admin.wd.email': 'E-mail',
  'admin.wd.submitted': 'Envoyée le',
  'admin.wd.created': 'Créée le',

  'admin.clients.title': 'Clients',
  'admin.clients.subtitle': 'Les fiches clients sont créées automatiquement à chaque nouveau virement.',
  'admin.clients.search': 'Rechercher un client',
  'admin.clients.new': 'Nouveau client',
  'admin.clients.name': 'Nom complet',
  'admin.clients.email': 'E-mail',
  'admin.clients.phone': 'Téléphone',
  'admin.clients.currency': 'Devise',
  'admin.clients.card': 'Carte de démonstration',
  'admin.clients.balance': 'Solde',
  'admin.clients.status': 'Statut',
  'admin.clients.actions': 'Actions',
  'admin.clients.active': 'Actif',
  'admin.clients.disabled': 'Désactivé',
  'admin.clients.empty': 'Aucun client pour le moment.',
  'admin.clients.bankLogin': 'Identifiant bancaire',
  'admin.clients.manage': 'Gérer',
  'admin.clients.create.title': 'Créer un client',
  'admin.clients.create.subtitle': 'Une carte de démonstration et des identifiants seront générés automatiquement.',
  'admin.clients.create.amount': 'Montant initial',
  'admin.clients.create.done': 'Compte créé',
  'admin.clients.create.credentials': 'Identifiants générés',
  'admin.clients.create.accessCode': 'Code d’identification',
  'admin.clients.create.bankLogin': 'Identifiant bancaire',
  'admin.clients.create.bankPassword': 'Mot de passe bancaire',
  'admin.clients.create.warning': 'Communiquez ces informations par un canal sécurisé. Elles ne seront plus affichées ensuite.',
  'admin.clients.create.card': 'Marque de la carte de démonstration',
  'admin.clients.create.submit': 'Créer le compte',
  'admin.clients.create.missing': 'Le nom complet est obligatoire.',
  'admin.clients.create.invalidEmail': 'L’adresse e-mail n’est pas valide.',
  'admin.clients.detail.title': 'Fiche client',
  'admin.clients.detail.since': 'client depuis le',
  'admin.clients.detail.card': 'Carte de démonstration',
  'admin.clients.detail.adjust': 'Ajuster le solde',
  'admin.clients.detail.adjustAmount': 'Montant (négatif pour débiter)',
  'admin.clients.detail.adjustLabel': 'Libellé de l’opération',
  'admin.clients.detail.adjustSubmit': 'Enregistrer',
  'admin.clients.detail.regen': 'Régénérer le code',
  'admin.clients.detail.disable': 'Désactiver',
  'admin.clients.detail.enable': 'Réactiver',
  'admin.clients.detail.transactions': 'Historique des transactions',
  'admin.clients.detail.withdrawals': 'Demandes de retrait',
  'admin.clients.detail.noTx': 'Aucune transaction.',
  'admin.clients.detail.updated': 'Mise à jour effectuée.',
  'admin.clients.detail.newCode': 'Nouveau code d’identification',
  'admin.clients.detail.invalidAmount': 'Saisissez un montant différent de zéro.',
  'admin.clients.detail.balanceError': 'Ajustement impossible : solde insuffisant.',
  'admin.clients.detail.transfers': 'Virements liés',
  'admin.clients.detail.sendCredentials': 'Envoyer les identifiants',
  'admin.clients.detail.credentialsTitle': 'Identifiants générés',
  'admin.clients.detail.noEmail': 'Aucune adresse e-mail enregistrée pour ce client.',
  'admin.clients.detail.deleteTitle': 'Supprimer la fiche client',
  'admin.clients.detail.deleteText': 'Cette action est définitive : la fiche, ses identifiants et ses sessions seront supprimés. Le virement lié reste consultable.',
  'admin.clients.detail.deleteConfirm': 'Supprimer définitivement',

  'admin.codes.title': 'Codes de validation',
  'admin.codes.subtitle': 'Générez et gérez les codes de confirmation.',
  'admin.codes.empty': 'Aucun code généré.',
  'admin.codes.code': 'Code',
  'admin.codes.operation': 'Opération',
  'admin.codes.attempts': 'Tentatives',
  'admin.codes.expires': 'Expire le',
  'admin.codes.revoke': 'Invalider',
  'admin.codes.generate': 'Générer un code',
  'admin.codes.generateHint': 'Le code est valable une seule fois.',
  'admin.codes.ref': 'Référence de l’opération',
  'admin.codes.validity': 'Validité (min)',
  'admin.codes.created': 'Code généré',
  'admin.codes.type.withdrawal': 'Retrait',
  'admin.codes.type.settings': 'Paramètres',
  'admin.codes.type.login': 'Connexion sensible',
  'admin.codes.state.active': 'Actif',
  'admin.codes.state.used': 'Utilisé',
  'admin.codes.state.expired': 'Expiré',

  'admin.banks.title': 'Banques',
  'admin.banks.subtitle': 'Liste proposée dans le formulaire de retrait.',
  'admin.banks.add': 'Ajouter une banque',
  'admin.banks.name': 'Nom de la banque',
  'admin.banks.country': 'Pays',
  'admin.banks.swift': 'Code SWIFT',
  'admin.banks.order': 'Ordre',
  'admin.banks.active': 'Banque active',
  'admin.banks.save': 'Enregistrer',
  'admin.banks.empty': 'Aucune banque enregistrée.',
  'admin.banks.saved': 'Banque enregistrée.',
  'admin.banks.edit': 'Modifier la banque',
  'admin.banks.nameRequired': 'Le nom de la banque est obligatoire.',
  'admin.banks.toggle': 'Activer ou désactiver',
  'admin.banks.activeLabel': 'Active',
  'admin.banks.inactiveLabel': 'Inactive',

  'admin.ip.title': 'Blocage IP',
  'admin.ip.subtitle': 'Surveillez les tentatives de connexion et bloquez les réseaux suspects.',
  'admin.ip.address': 'Adresse IP',
  'admin.ip.country': 'Pays estimé',
  'admin.ip.attempts': 'Tentatives',
  'admin.ip.failures': 'Échecs',
  'admin.ip.lastSeen': 'Dernière activité',
  'admin.ip.block': 'Bloquer',
  'admin.ip.unblock': 'Débloquer',
  'admin.ip.blocked': 'Bloquée',
  'admin.ip.blockedTitle': 'Adresses bloquées',
  'admin.ip.blockedHint': 'Les blocages sont appliqués côté serveur.',
  'admin.ip.empty': 'Aucune adresse bloquée.',
  'admin.ip.emptyAttempts': 'Aucune tentative enregistrée.',
  'admin.ip.note': 'Géolocalisation approximative',
  'admin.ip.until': 'Jusqu’au',
  'admin.ip.permanent': 'Blocage permanent',
  'admin.ip.blockTitle': 'Bloquer une adresse IP',
  'admin.ip.blockWarning': 'Les sessions actives de cette adresse seront immédiatement fermées.',
  'admin.ip.reason': 'Motif du blocage',
  'admin.ip.reasonPh': 'Tentatives répétées, comportement suspect…',
  'admin.ip.hours': 'Durée (heures)',
  'admin.ip.hoursHint': '0 = blocage permanent',
  'admin.ip.blockedDone': 'Adresse IP bloquée.',
  'admin.ip.unblockedDone': 'Blocage levé.',
  'admin.ip.stateActive': 'Actif',
  'admin.ip.stateLifted': 'Levé',
  'admin.ip.manualTitle': 'Bloquer manuellement une adresse',
  'admin.ip.manualSubtitle': 'Saisissez une adresse IP pour la bloquer immédiatement.',
  'admin.ip.manualDefaultReason': 'Blocage manuel administrateur',
  'admin.ip.invalidIp': 'Adresse IP invalide.',
  'admin.ip.invalidDuration': 'Durée invalide (0 à 8760 heures).',
  'admin.ip.historyTitle': 'Historique des blocages',
  'admin.ip.historyHint': 'Toutes les actions de blocage et de déblocage.',
  'admin.ip.historyEmpty': 'Aucun événement de blocage.',
  'admin.ip.historyBlocked': 'Adresse bloquée',
  'admin.ip.historyUnblocked': 'Blocage levé',

  'admin.logs.title': 'Journaux d’activité',
  'admin.logs.subtitle': 'Historique des actions sensibles de la plateforme.',
  'admin.logs.date': 'Date',
  'admin.logs.actor': 'Acteur',
  'admin.logs.action': 'Action',
  'admin.logs.target': 'Cible',
  'admin.logs.ip': 'Adresse IP',
  'admin.logs.empty': 'Aucun événement enregistré.',
  'admin.logs.search': 'Filtrer par action',
  'admin.logs.apply': 'Filtrer',

  'admin.settings.title': 'Réglages',
  'admin.settings.subtitle': 'Paramètres de la plateforme et de la sécurité.',
  'admin.settings.general': 'Général',
  'admin.settings.platformName': 'Nom de la plateforme',
  'admin.settings.supportEmail': 'E-mail du support (affiché aux clients)',
  'admin.settings.adminEmail': 'E-mail de connexion administrateur',
  'admin.settings.adminEmailHint': 'Une vérification est requise avant activation.',
  'admin.settings.maxAttempts': 'Tentatives de connexion autorisées',
  'admin.settings.generalSaved': 'Paramètres enregistrés.',
  'admin.settings.security': 'Mot de passe administrateur',
  'admin.settings.currentPassword': 'Mot de passe actuel',
  'admin.settings.newPassword': 'Nouveau mot de passe',
  'admin.settings.confirmPassword': 'Confirmer le mot de passe',
  'admin.settings.changePassword': 'Modifier le mot de passe',
  'admin.settings.passwordRules': '10 caractères minimum, avec majuscule, minuscule et chiffre.',
  'admin.settings.passwordWeak': 'Le mot de passe ne respecte pas les exigences.',
  'admin.settings.passwordMismatch': 'Les mots de passe ne correspondent pas.',
  'admin.settings.passwordWrong': 'Mot de passe actuel incorrect.',
  'admin.settings.passwordDone': 'Mot de passe modifié.',
  'admin.settings.invalidEmail': 'L’adresse e-mail n’est pas valide.',
  'admin.settings.notifications': 'Notifications Telegram',
  'admin.settings.telegramEnabled': 'Activer les notifications Telegram',
  'admin.settings.telegramToken': 'Jeton du bot',
  'admin.settings.telegramChat': 'Identifiant du canal',
  'admin.settings.telegramHint': 'Les alertes partent dès que le jeton et le canal sont renseignés.',
  'admin.settings.siteUrl': 'URL publique du site',
  'admin.settings.siteUrlHint': 'Utilisée dans les boutons des e-mails (ex. https://monexa.app).',
  'admin.settings.senderName': 'Nom d’expéditeur des e-mails',
  'admin.settings.senderNameHint': 'Nom affiché dans la boîte de réception du destinataire.',
  'admin.settings.role': 'Rôle de ce compte',
  'admin.settings.emailSending': 'Envoi des e-mails',
  'admin.settings.emailSender': 'Adresse d’expédition',
  'admin.settings.emailReady': 'Domaine actif',
  'admin.settings.emailMissing': 'Domaine non configuré',

  'admin.data.title': 'Gestion et suppression',
  'admin.data.subtitle': 'Supprimez définitivement des données. Action irréversible.',
  'admin.data.clients': 'Comptes clients',
  'admin.data.withdrawals': 'Demandes de retrait',
  'admin.data.transfers': 'Virements',
  'admin.data.codes': 'Codes de validation',
  'admin.data.ips': 'Adresses IP bloquées',
  'admin.data.delete': 'Supprimer',
  'admin.data.confirmTitle': 'Confirmer la suppression',
  'admin.data.confirmText': 'Cette action est définitive. Les données liées seront également supprimées et aucun retour en arrière n’est possible.',
  'admin.data.deleted': 'Suppression effectuée.',
  'admin.data.empty': 'Aucun élément.',

  'admin.roles.owner': 'Propriétaire',
  'admin.roles.admin': 'Administrateur',
  'admin.roles.support': 'Support',

  'admin.emailState.sent': 'Envoyé',
  'admin.emailState.failed': 'Échec',
  'admin.emailState.queued': 'En file',
  'admin.emailState.not_configured': 'Non configuré',

  'admin.transfers.statTotal': 'Virements',
  'admin.transfers.statPending': 'En attente',
  'admin.transfers.statExecuted': 'Exécutés',
  'admin.transfers.statMail': 'E-mails à vérifier',
  'admin.transfers.title': 'Virements bancaires',
  'admin.transfers.subtitle': 'Créez un virement vers un bénéficiaire et suivez sa notification.',
  'admin.transfers.new': 'Nouveau virement',
  'admin.transfers.newHint': 'Le bénéficiaire reçoit immédiatement un e-mail avec un lien vers l’authentification bancaire.',
  'admin.transfers.empty': 'Aucun virement enregistré.',
  'admin.transfers.ref': 'Référence',
  'admin.transfers.beneficiary': 'Bénéficiaire',
  'admin.transfers.bank': 'Banque bénéficiaire',
  'admin.transfers.amount': 'Montant',
  'admin.transfers.status': 'Statut',
  'admin.transfers.emailStatus': 'Notification',
  'admin.transfers.date': 'Date',
  'admin.transfers.open': 'Ouvrir',
  'admin.transfers.submit': 'Créer le virement',
  'admin.transfers.missing': 'Merci de compléter tous les champs obligatoires.',
  'admin.transfers.invalidEmail': 'L’adresse e-mail n’est pas valide.',
  'admin.transfers.invalidIban': 'L’IBAN semble incorrect (8 caractères minimum).',
  'admin.transfers.invalidAmount': 'Le montant doit être supérieur à zéro.',
  'admin.transfers.amountTooHigh': 'Le montant dépasse le plafond autorisé ({{max}}).',
  'admin.transfers.amountHint': 'Plafond : {{max}}.',
  'admin.transfers.invalidBank': 'Sélectionnez une banque bénéficiaire active.',
  'admin.transfers.createdSent': 'Virement {{reference}} créé, notification envoyée au bénéficiaire.',
  'admin.transfers.createdNoMail': 'Virement {{reference}} créé, mais la notification n’a pas pu être envoyée. Vérifiez la configuration e-mail.',
  'admin.transfers.alreadyExecuted': 'Ce virement a déjà été exécuté.',
  'admin.transfers.resent': 'Notification renvoyée.',
  'admin.transfers.resendFailed': 'Renvoi impossible : la configuration e-mail est incomplète.',
  'admin.transfers.updated': 'Virement mis à jour.',
  'admin.transfers.detail': 'Détail du virement',
  'admin.transfers.resend': 'Renvoyer l’e-mail',
  'admin.transfers.cancel': 'Annuler le virement',
  'admin.transfers.execute': 'Marquer exécuté',
  'admin.transfers.by': 'Créé par',
  'admin.transfers.note': 'Note interne',
  'admin.transfers.notePh': 'Référence externe, instruction…',
  'admin.transfers.firstName': 'Prénom du bénéficiaire',
  'admin.transfers.lastName': 'Nom du bénéficiaire',
  'admin.transfers.email': 'E-mail du bénéficiaire',
  'admin.transfers.iban': 'IBAN du bénéficiaire',
  'admin.transfers.currency': 'Devise',
  'admin.transfers.lang': 'Langue du bénéficiaire',
  'admin.transfers.bankPh': 'Sélectionnez une banque',
  'admin.transfers.mailInfo': 'Un e-mail contenant le montant et un bouton « Activer mon virement » est envoyé au bénéficiaire dès la validation.',
  'admin.transfers.emailError': 'Erreur d’envoi',
  'admin.transfers.activation': 'Authentification bancaire',
  'admin.transfers.activationLink': 'Lien d’activation du bénéficiaire',
  'admin.transfers.activationHint': 'Ce lien ouvre la page d’authentification bancaire rattachée à la banque sélectionnée.',
  'admin.transfers.copyLink': 'Copier le lien',
  'admin.transfers.openLink': 'Ouvrir la page',
  'admin.transfers.linkCopied': 'Lien d’activation copié.',
  'admin.transfers.verifiedAt': 'Authentifié le',
  'admin.transfers.awaitingAuth': 'En attente d’authentification bancaire',
  'admin.transfers.notVerified': 'Le bénéficiaire doit d’abord s’authentifier auprès de sa banque avant que le virement puisse être exécuté.',
  'admin.transfers.resendHint': 'Un nouveau lien est généré, les tentatives sont réinitialisées et l’e-mail est renvoyé.',
  'admin.transfers.statVerified': 'Authentifiés',
  'admin.transfers.authAttempts': 'Tentatives incorrectes',
  'admin.transfers.filterVerified': 'Authentifiés',
  'admin.transfers.linkColumn': 'Lien',
  'admin.transfers.linkActive': 'Actif',
  'admin.transfers.linkDisabled': 'Désactivé',
  'admin.transfers.linkDisable': 'Désactiver le lien',
  'admin.transfers.linkEnable': 'Réactiver le lien',
  'admin.transfers.linkDisabledAt': 'Lien désactivé le {{date}}.',
  'admin.transfers.linkDisabledHint': 'Ce lien est désactivé : la page est inaccessible.',
  'admin.transfers.linkEnabled': 'Lien réactivé.',
  'admin.transfers.linkDisableDone': 'Lien désactivé.',
  'admin.transfers.pdfOpen': 'Aperçu PDF',
  'admin.transfers.pdfDownload': 'Télécharger le PDF',
  'admin.transfers.clientRecord': 'Fiche client associée',
  'admin.transfers.clientLogin': 'Identifiant',
  'admin.transfers.clientLinked': 'Fiche créée',
  'admin.transfers.clientCreated': 'Fiche client, carte et identifiants générés automatiquement (identifiant : {{login}}).',
  'admin.transfers.noClient': 'Aucune fiche client associée à ce virement.',
  'admin.transfers.sendCredentials': 'Envoyer les identifiants',
  'admin.transfers.credentialsSent': 'Identifiants envoyés au bénéficiaire.',
  'admin.transfers.credentialsNotSent': 'Identifiants générés mais e-mail non délivré.',
  'admin.transfers.statLinks': 'Liens désactivés',

  'admin.mail.compose': 'Nouveau message',
  'admin.mail.composeHint': 'Rédigez un e-mail personnalisé à un client.',
  'admin.mail.recipient': 'Destinataire (client)',
  'admin.mail.recipientPh': 'Sélectionnez un client',
  'admin.mail.recipientManual': 'Ou saisir une adresse e-mail',
  'admin.mail.templates': 'Modèles prédéfinis',
  'admin.mail.tpl.welcome': 'Bienvenue',
  'admin.mail.tpl.transfer_info': 'Virement reçu',
  'admin.mail.tpl.security': 'Alerte sécurité',
  'admin.mail.tpl.withdrawal': 'Suivi retrait',
  'admin.mail.tpl.reminder': 'Relance activation',
  'admin.mail.subject': 'Objet',
  'admin.mail.subjectPh': 'Objet de l’e-mail',
  'admin.mail.message': 'Message',
  'admin.mail.messagePh': 'Rédigez votre message…',
  'admin.mail.preview': 'Prévisualiser',
  'admin.mail.send': 'Envoyer l’e-mail',
  'admin.mail.sent': 'E-mail envoyé.',
  'admin.mail.notSent': 'E-mail non envoyé : la configuration d’envoi est incomplète.',
  'admin.mail.missing': 'Destinataire, objet et message sont obligatoires.',
  'admin.mail.invalidEmail': 'L’adresse e-mail n’est pas valide.',
  'admin.mail.deliveryInfo': 'Les envois nécessitent une clé et un domaine d’envoi configurés dans le panneau Resend. Sans cela, l’e-mail est enregistré mais non délivré.',
  'admin.mail.history': 'Historique des e-mails',
  'admin.mail.historyHint': 'Tous les messages transmis et leur statut.',
  'admin.mail.empty': 'Aucun e-mail envoyé.',

  'admin.cred.title': 'Identifiants et accès',
  'admin.cred.subtitle': 'Générez de nouveaux identifiants et transmettez-les au client par e-mail.',
  'admin.cred.client': 'Client',
  'admin.cred.clientPh': 'Sélectionnez un client',
  'admin.cred.email': 'Adresse d’envoi',
  'admin.cred.emailHint': 'Les identifiants seront envoyés à cette adresse.',
  'admin.cred.current': 'Compte sélectionné',
  'admin.cred.warning': 'La génération invalide les identifiants actuels et déconnecte le client de toutes ses sessions.',
  'admin.cred.generate': 'Générer et envoyer les identifiants',
  'admin.cred.done': 'Identifiants générés',
  'admin.cred.mailSent': 'Identifiants envoyés à {{email}}.',
  'admin.cred.mailNotSent': 'Identifiants générés, mais l’e-mail n’a pas pu être délivré. Communiquez-les manuellement.',
  'admin.cred.history': 'Historique des envois',
  'admin.cred.historyHint': 'Chaque génération est journalisée.',
  'admin.cred.empty': 'Aucun envoi d’identifiants.',

  'admin.authState.created': 'Lien envoyé',
  'admin.authState.identity_verified': 'Identité vérifiée',
  'admin.authState.authenticated': 'Authentifié',
  'admin.authState.locked': 'Verrouillé',
  'admin.authState.closed': 'Clôturé',

  'flow.eyebrow': 'Virement bancaire reçu',
  'flow.title': 'Un virement vous est destiné',
  'flow.subtitle': 'Vérifiez l’opération puis authentifiez-vous auprès de votre banque pour en confirmer la réception.',
  'flow.amount': 'Montant reçu',
  'flow.beneficiary': 'Bénéficiaire',
  'flow.bank': 'Banque bénéficiaire',
  'flow.reference': 'Référence',
  'flow.date': 'Date de l’opération',
  'flow.bankPanelTitle': 'Établissement concerné',
  'flow.secure1': 'Connexion chiffrée de bout en bout',
  'flow.secure2': 'Vérification auprès de la banque émettrice',
  'flow.secure3': 'Chaque étape est journalisée',
  'flow.footnote': 'Ne communiquez jamais vos identifiants par téléphone ou par e-mail.',
  'flow.bankTitle': 'Authentification bancaire',
  'flow.bankText': 'Identifiez-vous au service en ligne de {{bank}} pour autoriser la réception de ce virement.',
  'flow.login': 'Identifiant bancaire',
  'flow.loginPh': 'Votre identifiant bancaire',
  'flow.password': 'Mot de passe bancaire',
  'flow.passwordPh': 'Votre mot de passe',
  'flow.authSubmit': 'Autoriser la réception',
  'flow.authSubmitting': 'Connexion sécurisée…',
  'flow.attempts': '{{left}} tentative(s) restante(s)',
  'flow.secure': 'Identifiants jamais conservés',
  'flow.errorCredentials': 'Identifiants refusés par la banque. Il vous reste {{left}} tentative(s).',
  'flow.errorRequired': 'Merci de renseigner vos identifiants bancaires.',
  'flow.successTitle': 'Authentification confirmée',
  'flow.successText': 'Votre identité bancaire a bien été vérifiée. Le virement est validé et va être traité par l’émetteur.',
  'flow.successPending': 'Aucune action supplémentaire n’est requise de votre part. Vous pouvez fermer cette page.',
  'flow.verifiedAt': 'Vérifié le',
  'flow.lockedTitle': 'Lien d’activation verrouillé',
  'flow.lockedText': 'Trop de tentatives incorrectes. Pour votre sécurité, cette opération est suspendue. Contactez l’émetteur du virement pour obtenir un nouveau lien.',
  'flow.expiredTitle': 'Lien expiré',
  'flow.expiredText': 'Ce lien d’activation n’est plus valable. Contactez l’émetteur du virement pour en obtenir un nouveau.',
  'flow.cancelledTitle': 'Opération annulée',
  'flow.cancelledText': 'Cette opération a été annulée par l’émetteur du virement.',
  'flow.executedTitle': 'Virement déjà exécuté',
  'flow.executedText': 'Ce virement a déjà été exécuté. Aucune action supplémentaire n’est requise.',
  'flow.linkDisabledTitle': 'Lien désactivé',
  'flow.linkDisabledText': 'Ce lien a été désactivé par l’émetteur du virement. Contactez-le pour obtenir de nouvelles instructions.',
  'flow.blockedTitle': 'Accès bloqué',
  'flow.blockedText': 'L’accès depuis votre réseau a été bloqué pour raison de sécurité. Contactez l’émetteur du virement.',
  'flow.notFoundTitle': 'Opération introuvable',
  'flow.notFoundText': 'Ce lien est incomplet ou n’existe plus. Vérifiez l’e-mail reçu ou contactez le support.',
  'flow.statusLabel': 'Statut de l’opération',

  'status.draft': 'Brouillon',
  'status.pending': 'En attente',
  'status.verified': 'À exécuter',
  'status.approved': 'Approuvée',
  'status.rejected': 'Refusée',
  'status.executed': 'Exécutée',
  'status.cancelled': 'Annulé',
  'status.auth_failed': 'Authentification échouée',
};